import { rest, isApiError } from 'services'
import { createAction } from 'redux-actions'
import { change, untouch, SubmissionError } from 'redux-form'
import { extractSizes } from 'helpers/createTireSizeString'
import { withTireSizeInners } from 'components/VehicleConfigurator'
import { LICENSE_PLATE_DO_NOT_MATCH_CODE, LICENSE_PLACE_DO_NOT_MATCH_DESCRIPTION } from 'constant'
import { SIZE_NOT_LISTED_OPTION } from './constants'
import { VEHICLE_DETAILS_FORM } from '../constants'
import { prepareVehicleData, parseSizes } from './helpers'
import { getVehicleUpdateHandler } from '../selectors'
import { triggerNotification } from 'components/common/Notification/helpers'
import { isErrorCode, isErrorDescription } from 'helpers/utils'

export const getStatesRequest = createAction('SHOP_BY_LICENCE_PLATE/GET_STATES_REQUEST')
export const getStatesSuccess = createAction('SHOP_BY_LICENCE_PLATE/GET_STATES_SUCCESS')
export const getStatesFailure = createAction('SHOP_BY_LICENCE_PLATE/GET_STATES_FAILURE')

const {
  actions: { submit, reset }
} = withTireSizeInners

export const resetFormFields = (fields = {}) => dispatch => {
  const values = Object.keys(fields)
  values
    .forEach(value => {
      dispatch(change(VEHICLE_DETAILS_FORM, value, ''))
      dispatch(untouch(VEHICLE_DETAILS_FORM, value))
    })
}

export const getStatesApi = () => async dispatch => {
  dispatch(getStatesRequest())

  try {
    const { garageResponse: { states }} = await rest.api.getStates()
    dispatch(getStatesSuccess(states))
  } catch (err) {
    dispatch(getStatesFailure(err))
  }
}

const updateVehicle = (
  { mileage, engine, tires, nickname, licencePlateNumber, state },
  { vehicleEngineType, userVehicleDetails: { subModelImage, editVehicle, ...userVehicleDetails }}
) => async (dispatch, getState) => {
  const { engineId, engineDesc } = vehicleEngineType.find(({ engineId }) => engineId === Number(engine)) || {}
  await rest.api.updateVehicle({
    ...prepareVehicleData(userVehicleDetails),
    ...tires,
    mileage,
    engineConfigId: engineId,
    engineDesc,
    nickname,
    licencePlateNumber,
    state,
    editVehicle: editVehicle && editVehicle
  })
    .then(() => {
      const onSuccess = getVehicleUpdateHandler(getState())
      dispatch(onSuccess(userVehicleDetails))
      triggerNotification()
    })
    .catch(err => {
      if (isApiError(err)) {
        if (
          isErrorCode({ err, code: LICENSE_PLATE_DO_NOT_MATCH_CODE }) &&
          isErrorDescription({ err, description: LICENSE_PLACE_DO_NOT_MATCH_DESCRIPTION })
        ) {
          throw new SubmissionError({
            _error: err.statusList[0].description
          })
        }
      }
    })
}

export const handleSubmit = ({ tires, ...values }, dispatch, props) => {
  if (tires === SIZE_NOT_LISTED_OPTION) {
    const { valid, tireSizes } = dispatch(submit(true))
    if (valid) {
      const { tireFrontSize, tireRearSize } = extractSizes(tireSizes)
      return dispatch(updateVehicle({
        ...values,
        tires: {
          tireFrontSize,
          tireRearSize: tireRearSize || null,
          hasStaggeredFitment: Boolean(tireRearSize)
        }
      }, props))
    }
  } else if (!tires) {
    return dispatch(updateVehicle({
      ...values,
      tires: {
        tireFrontSize: '',
        tireRearSize: '',
        hasStaggeredFitment: false
      }
    }, props))
  } else {
    const parsedSizes = parseSizes(tires || '')
    return dispatch(updateVehicle({ ...values, tires: parsedSizes }, props))
  }
}

export const resetForm = () => reset()
